// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7863":"2b41014c","9606":"9b2aacd9"}[chunkId] + ".chunk.css";
};